import { OK } from 'http-status-codes'
import getAxiosInstance from '../../helpers/get_axios_instance'

// Llamada a LRS
class CuadroDeMandoExpCereal {
  static getCdmdExpCereal () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/cdmd_exportador_cereal`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado.')
      return data
    })
  };

  static getCdmdCereal () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/cdmd_cereal_total`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado.')
      return data
    })
  };

  static getCdmdCerealPesoTotal () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/cdmd_cereal_peso_total_listado`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudieron obtener los datos')
      return data
    })
  }
}

export default CuadroDeMandoExpCereal
